import React, { useContext, useEffect, useState } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import { useNavigate, useParams } from "react-router-dom";
import { AuthContext } from "../../../config/AuthContext";
import AppSider from "../../components/AppSider";
import { Content } from "antd/es/layout/layout";
import Login from "../../Login";
import { Button, FloatButton, Progress, Table, TableProps, Tag } from "antd";
import AvaluacioColors from "../../../styles/AvaluacioColors";
import { BiArrowFromLeft, BiPencil, BiPlus, BiRefresh } from "react-icons/bi";
import ProjecteModal from "../../avaluacio/projectes/ProjecteModal";
import { ColumnsType } from "antd/es/table";
import { GetAllAules } from "../../../dao/GetAllAules";
import HomeColors from "../../../styles/HomeColors";
import AulaModal from "../AulaModal";
import { GetAlumne } from "../../../dao/abp/GetAlumnes";
import { FaArrowRight, FaBrain, FaRegFileExcel, FaRegFilePdf } from "react-icons/fa";
import RaModal from "../RaModal";
import { GetProjecteIdConfiguracio } from "../../../dao/abp/GetProjecteIdConfiguracio";
import { GetAulaIdConfiguracio } from "../../../dao/GetAulaIdConfiguracio";
import { GetAlumneId } from "../../../dao/GetAlumneId";

const Aules = () => {
    const { isLoggedIn, userId, user, setBreadCrumb, alumne } = useContext(AuthContext);
    const navigate = useNavigate();
    const { id } = useParams();
    const [dades, setDades] = (useState<any[]>([]))
    const [pantalla, setPantalla] = useState(0);
    const [modal, setModal] = useState(false);
    const [json, setJson] = useState<any>();
    const [modalRA, setModalRA] = useState(false);
    const [selected, setSelected] = useState<any>();
    const [alumnes, setAlumnes] = useState<any>([]);
    const [selectedIds, setSelectedIds] = useState<any>([]);

    const [loading, setLoading] = useState(false);

    useEffect(() => {
        if (isLoggedIn) {
            setBreadCrumb([{ nom: 'Home', nav: '/home' },
            { nom: 'aules', nav: '/aules' }], true);
            checkDades();
            getAlumnes();
        }
    }, []);

    async function getAlumnes() {
        const alus = await GetAlumne();
        setAlumnes(alus);
    }

    const colors = [
        HomeColors.colors.color1,
        HomeColors.colors.color2,
        HomeColors.colors.color3,
        HomeColors.colors.color4,
        HomeColors.colors.color5,
        HomeColors.colors.color6
    ];

    async function checkDades() {
        setLoading(true);
        if (user.tipus === "0")
            setDades(await GetAllAules(""));
        else
            setDades((await GetAlumneId(userId)).aules);
        setLoading(false);
    }

    function setPnt(value: number) {
        setPantalla(value);
    }
    const columns: ColumnsType<any> = [
        {
            key: 'id',
            dataIndex: 'id',
            width: 15,
            responsive: ['lg'],
        },
        {
            key: 'nom',
            dataIndex: 'nom',
            width: 30,
        },
        {
            key: 'projectes',
            dataIndex: 'projectes',
            width: 30,
            render: (e, ele) => (
                <>
                    {e?.split(",").map((project: any, index: any) => (
                        <Tag key={index} color={colors[index % colors.length]} title={project.trim()}>
                            {project.trim()}
                        </Tag>
                    ))}
                </>
            )
        },
        {
            key: 'actions',
            dataIndex: 'actions',
            width: 100,
            render: (e, ele) => (

                ele.tipus === 0 && <>
                    {user.tipus === "0" && <><Button title={"Editar"} onClick={() => editar(ele)}
                        style={{ backgroundColor: HomeColors.colors.color6 }}><BiPencil /></Button>

                        {" "}
                        <Button title={"RAs"} onClick={() => editarRA(ele)}
                            style={{ backgroundColor: HomeColors.colors.color5 }}><FaBrain /></Button></>
                    }
                    {" "}
                    <Button title={"Notes Pdf"} onClick={() => editarRA(ele)}
                        style={{ backgroundColor: HomeColors.colors.color4 }}><FaRegFilePdf /></Button>
                    {" "}
                    <Button title={"Notes Excel"} onClick={() => editarRA(ele)}
                        style={{ backgroundColor: HomeColors.colors.color3 }}><FaRegFileExcel /></Button>
                    {" "}
                    <Button title={"Acceder"} onClick={() => navigate(`${ele.id}`)}
                        style={{ backgroundColor: HomeColors.colors.color2 }}><FaArrowRight /></Button>
                </>

            ),
        },
    ];

    const tableProps: TableProps<any> = {
        loading
    };

    function onClose(value: boolean) {
        if (value)
            checkDades();
        setModal(false);
        setLoading(false);
    }
    function onCloseRA(value: boolean) {
        if (value)
            checkDades();
        setModalRA(false);
        setLoading(false);
    }


    function editar(ele: any) {
        setLoading(true);
        setSelected(ele);

        const ids = ele.alumnes?.map((alumne: any) => alumne.id);

        setSelectedIds(ids);
        setModal(true);
    }

    async function editarRA(ele: any) {
        setLoading(true);
        setSelected(ele);


        const data = await GetAulaIdConfiguracio(ele.id + "", 0);
        const formattedData = { items: data };
        setJson(formattedData);
        console.log(JSON.stringify(formattedData));

        setModalRA(true);
    }

    function nou() {
        setLoading(true);
        setModal(true);
        setSelected({ id: 0 });
    }

    if (isLoggedIn) {
        return (
            <>
                <AppSider currentVal={3} setPantalla={setPnt} />
                <Content style={{ padding: '0 24px', minHeight: 280 }}>
                    <Table
                        showHeader={false}
                        size={"small"}
                        title={() => "AULES"}
                        {...tableProps}
                        bordered={true}
                        columns={columns}
                        dataSource={dades}
                    />
                </Content>


                {(user.tipus === "0" || user.tipus === "1") && !loading && <FloatButton
                    shape="circle"
                    onClick={() => nou()}
                    style={{ insetInlineEnd: 94, backgroundColor: AvaluacioColors.colors.color6 }}
                    icon={<BiPlus />}
                />}

                {(user.tipus === "1" || user.tipus === "0") && !loading && <FloatButton
                    shape="circle"
                    onClick={() => checkDades()}
                    style={{ insetInlineStart: 97, backgroundColor: AvaluacioColors.colors.color6 }}
                    icon={<BiRefresh />}
                />}

                {modal && <AulaModal selectedIds={[]} alumnes={alumnes} element={{ id: 0 }}
                    visible={modal} onClose={onClose} />}
                {modalRA && <RaModal id_aula={"0"} element={selected} json={json}
                    visible={modalRA} onClose={onCloseRA} />}
            </>
        );
    } else {
        return (
            <Login />
        );
    }
};
export default Aules;
